const MapLegend = ({ filters, filtersKeys }) => {
  const legendItems = filters[filtersKeys[0]].values.map((legendItem, i) => {
    return (
      <div key={legendItem.name + i} className="legend-item">
        <svg
          x="0px"
          y="0px"
          viewBox="0 0 40 40"
          width="20px"
          height="20px"
          className="legend-icon"
        >
          <path
            className="st0"
            fill={legendItem.color}
            d="M20,2.6c-7.2,0-13.3,5.8-13.3,13.3c0,3,2.1,7.4,6,13c3,4,6,7.2,6,7.4l1.2,1.2l1.2-1.2c0.2-0.2,3-3.3,6-7.4
            c4.2-5.6,6-10,6-13C33.3,8.4,27.2,2.6,20,2.6z M20,20.5c-2.6,0-4.9-2.1-4.9-4.9s2.1-4.9,4.9-4.9s4.9,2.1,4.9,4.9S22.6,20.5,20,20.5z
            "
          />
        </svg>
        <span className="legend-title"> {legendItem.name}</span>
      </div>
    );
  });
  return <div className="map-legend">{legendItems}</div>;
};

export default MapLegend;
